import { AudienceGender } from "app/pages/sales-intelligence/domain/leads/types/enums";

export const TO_API: Partial<Record<AudienceGender, AudienceGender>> = {
    [AudienceGender.Female_80_100]: AudienceGender.Female_60_80,
    [AudienceGender.Male_80_100]: AudienceGender.Male_60_80,
};

export const FROM_API: Partial<Record<AudienceGender, AudienceGender>> = {
    [AudienceGender.Female_60_80]: AudienceGender.Female_80_100,
    [AudienceGender.Male_60_80]: AudienceGender.Male_80_100,
};
